import { Radio } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';

import { formatCurrency } from '../../../utils';
import { CurrencyInput, CurrencyInputChangeEvent } from '../../inputs';

export const slidePayInvoiceTableColumns = (
	disableEdit: boolean,
	handleInvoiceSelection: (invoiceId: string) => void,
	handlePaymentAmountChange?: (event: CurrencyInputChangeEvent, rowId: string) => void,
): GridColDef[] => {
	const viewOnlyColumns: GridColDef[] = [
		{
			field: 'readable_id',
			headerName: 'Invoice #',
			width: 350,
			flex: 2,
			editable: false,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			cellClassName: (params) => (params.id !== 'total' ? 'tableCell' : 'total-row'),
		},
		{
			field: 'created_at',
			headerName: 'Invoice Date',
			width: 120,
			flex: 1,
			editable: false,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			cellClassName: 'tableCell',
		},
		{
			field: 'amount',
			headerName: 'Invoice Amount',
			renderCell: (params) => formatCurrency(params.value),
			width: 100,
			flex: 1,
			editable: false,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			cellClassName: 'tableCell',
		},
		{
			field: 'balance',
			headerName: 'Invoice Balance',
			renderCell: (params) => formatCurrency(params.value),
			width: 100,
			flex: 1,
			editable: false,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			cellClassName: 'tableCell',
		},
		{
			field: 'payment',
			headerName: 'Payment Amount',
			width: 100,
			flex: 1,
			editable: false,
			resizable: false,
			sortable: false,
			headerAlign: 'center',
			cellClassName: 'tableCell',
			renderCell: (params) => {
				if (params.id === 'total') {
					return formatCurrency(Number(params.value));
				}

				if (!params.row.selected || !handlePaymentAmountChange) {
					return formatCurrency(0);
				}

				return (
					<CurrencyInput
						value={String(params.value)}
						onChange={(event) => handlePaymentAmountChange(event, params.row.id)}
						onBlur={(event) => handlePaymentAmountChange(event, params.row.id)}
					/>
				);
			},
		},
	];

	const selectionColumn: GridColDef = {
		field: 'selected',
		headerName: '',
		width: 100,
		editable: false,
		resizable: false,
		sortable: false,
		cellClassName: 'tableCell',
		renderCell: (params) => {
			if (params.id === 'total') {
				return null;
			}

			return <Radio checked={params.value} onChange={() => handleInvoiceSelection(params.id as string)} />;
		},
	};

	if (disableEdit) {
		return viewOnlyColumns;
	}

	return [selectionColumn, ...viewOnlyColumns];
};
